export default "__VITE_PUBLIC_ASSET__cf89315c__"